import { hasResellerAccess } from "../../helpers/hasResellerAccess";

const OnlyForSuperUser = ({ user, yes, no }) =>
  hasResellerAccess(user) ? yes() : no();

OnlyForSuperUser.defaultProps = {
    user: {},
	yes: () => null,
	no: () => null,
};

export default OnlyForSuperUser;